import React from "react";
import ReactDOM from "react-dom/client";
import HomePage from "./App";
import reportWebVitals from "./reportWebVitals";
import "./assets/styles/reset.css";
import "./assets/styles/responsive.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<HomePage />);
reportWebVitals();
